import {HTTP} from '@/http/http-client';

const checkUniqueEmail = (email) =>
    HTTP.post(`no-auth/parents/check-email`, email).then(({ data }) => data);

const signUp = (parentForm) =>
    HTTP.post(`no-auth/parents/slug`, parentForm).then(({ data }) => data);

const verifyEmail = (form) =>
    HTTP.patch(`no-auth/parents/verify-email`, form).then(({ data }) => data);

const verifyChangeEmail = (form) =>
    HTTP.patch(`no-auth/parents/email-update`, form).then(({ data }) => data);

const sendEmailForChangePassword = (email) =>
    HTTP.post(`no-auth/forgetPassword/parents/slug?email=${email}`).then(({ data }) => data);

const sendNewPassword = (passwordResetForm) =>
    HTTP.post(`no-auth/forgetPassword/resetPassword`, passwordResetForm).then(({ data }) => data);

const resendConfirmRegistration = (form) =>
    HTTP.post(`no-auth/parents/new-verification-token/slug`, form).then(({ data }) => data);

export default {
    checkUniqueEmail,
    signUp,
    verifyEmail,
    resendConfirmRegistration,
    verifyChangeEmail,
    sendEmailForChangePassword,
    sendNewPassword
};




// WEBPACK FOOTER //
// ./src/http/services/registrationService.js